export default class {
    constructor(obj) {
        this.id = obj.id
        this.left = obj.left
        this.top = obj.top
        this.content = obj.content
    }
}



// WEBPACK FOOTER //
// ./src/administration/dto/LegendDto.js